<template>
    <Head :titulo="servicio.nombre" />
    <div class="hero-bloque-mascara">
        <div class="hero-bloque-mascara__img">
            <img src="/img/hero-bloque-img-mascara.png" alt="">
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-7">
                    <h1 class="hero-encabezado">{{ servicio.nombre }}</h1>
                    <div class="hero-etiquetas">
                        <span v-if="servicio.enlinea == true" class="badge etiqueta-simple">En Línea</span>
                        <span v-if="servicio.presencial == true" class="badge etiqueta-simple">Presencial</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="breadcrumb-block-wrapper">
                            <ul class="breadcrumb-block">
                                <li class="breadcrumb-block__item">
                                    <Link href="/servicios" class="breadcrumb-block__section">Trámites y Servicios</Link>
                                </li>
                                <li class="breadcrumb-block__item">
                                    <Link :href="'/servicios?secretaria=' + servicio.secretaria.id" class="breadcrumb-block__section">{{ servicio.secretaria.nombre }}</Link>
                                </li>
                                <li class="breadcrumb-block__item active">
                                    <span class="breadcrumb-block__section">{{ servicio.nombre }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general pt-0">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-lg-7">
                        <div class="contenido-administrable">
                            <div class="row">
                                <div class="col-6 gris">
                                    <h6 class="mb-2"><strong>Folio de registro del {{ servicio.tipo.toLowerCase() }} </strong></h6>
                                    <p class="mb-4 mt-0" v-html="servicio.folio" />
                                </div>
                                <div class="col-6 gris">
                                    <h6 class="mb-2"><strong>Última actualización</strong></h6>
                                    <p class="mb-4 mt-0" v-html="servicio.ultima_actualizacion" />
                                </div>
                            </div>
                            <h6 class="mt-5"><strong>Descripción del {{ servicio.tipo }}</strong></h6>
                            <p class="mb-5" v-html="servicio.descripcion" />
                            <div v-if="servicio.presencial">
                                <h6><strong>Trámite Presencial</strong></h6>
                                <p class="mb-5" v-html="servicio.donde" />
                            </div>
                            <div v-if="servicio.enlinea">
                                <h6><strong>Trámite En Línea</strong></h6>
                                <p class="mb-5">
                                    <div v-html="servicio.tramite_linea" class="mb-3"></div>
                                    <Link v-if="servicio.formulario" :href="route('servicios.formulario', servicio.slug)" style="color:black;text-decoration: none;" class="boton-secundario boton-flecha">Iniciar trámite</Link>
                                </p>
                            </div>
                            <div v-if="servicio.telefonica">
                                <h6><strong>Trámite por Teléfono</strong></h6>
                                <p class="mb-5" v-html="servicio.tramite_telefonico" />
                            </div>
                            <div class="mb-5">
                                <p><strong>¿Qué documento se obtiene?:</strong> {{ servicio.documento_obtiene }}</p>
                            </div>
                            <div class="mb-5">
                                <p><strong>Afirmativa Ficta:</strong> {{ servicio.afirmativa_ficta }}</p>
                            </div>
                            <div class="mb-5">
                                <p><strong>Costo:</strong> {{ servicio.costo }}</p>
                            </div>

                            <div class="bloque-acordeon">
                                <div class="bloque-acordeon__item">
                                    <a v-b-toggle.collapse-1 class="bloque-acordeon__link collapsed">¿Qué documentos debo presentar?</a>
                                    <b-collapse id="collapse-1" class="bloque-acordeon__colapsable collapse">
                                        <div class="bloque-acordeon__colapsable-inner">
                                            <div class="contenido-administrable">
                                                <div id="documentacion" ref="documentacion" v-html="servicio.documentacion"></div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                                <div v-if="servicio.criterios_resolucion?.length > 0" class="bloque-acordeon__item">
                                    <a v-b-toggle.collapse-2 class="bloque-acordeon__link collapsed">¿Cuál es el plazo y criterio de resolución?</a>
                                    <b-collapse id="collapse-2" class="bloque-acordeon__colapsable collapse">
                                        <div class="bloque-acordeon__colapsable-inner">
                                            <div class="contenido-administrable">
                                                <div v-html="servicio.criterios_resolucion"></div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                                <div v-if="servicio.archivos?.length > 0" class="bloque-acordeon__item">
                                    <a v-b-toggle.collapse-3 class="bloque-acordeon__link collapsed">¿Qué pasos debo seguir para realizar el trámite?</a>
                                    <b-collapse id="collapse-3" class="bloque-acordeon__colapsable collapse">
                                        <div class="bloque-acordeon__colapsable-inner">
                                            <div class="contenido-administrable">
                                                <div v-for="(item, index) in JSON.parse(servicio.archivos)" :key="index">
                                                    <a :href="'/storage/' + item.attributes.archivo+'?u='+new Date().valueOf().toString()" class="link" target="_blank" download>{{ item.attributes.nombre }} <font-awesome-icon icon="fa-solid fa-download" class="ml-1" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                            <div class="bloque-boton" v-if="servicio.archivo != null">
                                <a :href="'/storage/' + servicio.archivo+'?u='+new Date().valueOf().toString()" target="_blank" class="boton-principal boton-descarga" download><font-awesome-icon icon="fa-solid fa-file" class="mr-1" /> Descargar ficha completa del {{ servicio.tipo }}</a>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="sidebar__wrapper">
                            <div v-if="servicio.enlinea && servicio.formulario" class="sidebar__seccion-cta fondo-gris-claro mb-4">
                                <h6 class="sidebar__encabezado">Trámite en línea</h6>
                                <h4 class="sidebar__subencabezado">¡Realizar tu trámite es muy sencillo!</h4>
                                <Link :href="route('servicios.formulario', servicio.slug)" class="boton-secundario boton-flecha">Iniciar trámite</Link>
                            </div>
                            <BannersBox :banners="banners" />
                            <div class="item-contacto">
                                <a :href="'tel:' + this.$telefono" class="link-telefono">{{ this.$telefono }}</a>
                                <Link href="/contacto" class="link-contacto">Contáctanos aquí</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '../../Shared/Head.vue';
import { Link } from '@inertiajs/inertia-vue3'
import BannersBox from '../../Shared/Banners/BannersBox.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFile } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
library.add([faFile, faDownload]);

export default {
    props: {
        servicio: Object,
        banners: Object,
    },
    components: {
        Head, Link, BannersBox
    },
    mounted() {
        const anchors = this.$refs.documentacion.getElementsByTagName('a'); // Not iterable

        Array.from(anchors).forEach(anchor => {
            const url = anchor.getAttribute('href');
            anchor.setAttribute('href', '/storage/'+url);
        })
    },
    computed: {
        urlClean() {
            let regex = /(<([^>]+)>)/ig;
            return this.servicio.tramite_linea.replace(regex, "");
        }
    }
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

.boton-descarga,
.bloque-acordeon__item a {
    color: #333;
    text-decoration: none;
}

.gris {
    border-bottom: 1px solid #ddd;
}

.bloque-acordeon__link {
    cursor: pointer;
}

.bloque-acordeon__link:hover {
    color: rgba(0, 0, 0, 0.5);
}

.boton-descarga:hover {
    color: #000;
    text-decoration: none;
}
.sidebar__encabezado {
    color: #B29966;
    font-size: 22px !important;
    margin-top: 0;
}
</style>
